import { render, staticRenderFns } from "./SingleProfile.vue?vue&type=template&id=2bd2f70a&scoped=true&"
import script from "./SingleProfile.vue?vue&type=script&lang=js&"
export * from "./SingleProfile.vue?vue&type=script&lang=js&"
import style0 from "./SingleProfile.vue?vue&type=style&index=0&id=2bd2f70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd2f70a",
  null
  
)

export default component.exports